const jquery = require("../assets/js/jquery.min.js");

export default window.$ = window.jQuery = jquery;
